import { GA } from '@gamiphy/analytics';
import {
  Coupon,
  DiscountCode, GiftCard, Transaction, Voucher, Wallet,
} from '@gamiphy/bl/reward';

// Discount Codes Events
export const trackDiscountCodeRedeemed = (data: {value: number, gems: number}): void => {
  GA.trackEvent('rewards', 'discount_codes.amount_redeemed', undefined, data.value);
  GA.trackEvent('rewards', 'discount_codes.points_redeemed', undefined, data.gems);
};
export const trackDiscountCodeRedeemedBack = (discountCode: DiscountCode): void => {
  GA.trackEvent('rewards', 'discount_codes.amount_redeemed_back', undefined, discountCode.value);
  GA.trackEvent('rewards', 'discount_codes.points_redeemed_back', undefined, discountCode.points.gems);
};

// Vouchers Events
export const trackVoucherRedeemed = (giftCard: GiftCard, voucher: Voucher): void => {
  GA.trackEvent('rewards', 'vouchers.amount_redeemed', giftCard.brand, voucher.value);
  GA.trackEvent('rewards', 'vouchers.points_redeemed', giftCard.brand, giftCard.points.gems);
};

// Transaction Events
export const trackTransactionRedeemed = (wallet: Wallet, transaction: Transaction): void => {
  GA.trackEvent('rewards', 'transactions.amount_redeemed', wallet.currency, transaction.value);
  GA.trackEvent('rewards', 'transactions.points_redeemed', wallet.currency, transaction.points.gems);
};

// Coupons Events
export const trackPromotionRedeemed = (coupon: Coupon): void => GA.trackEvent('rewards', 'coupons.amount_redeemed', undefined, coupon.value);
